import React from 'react';
import { PricingPageLayout } from '../components/shared/PricingPageLayout';
import { PricingBookContainer } from '../containers/PricingBookContainer/PricingBookContainer';
import { PricingBookV2Container } from '../containers/PricingBookV2Container/PricingBookV2Container';
import { useRewardsAndOffers } from '../hooks/use-rewards-and-offers';

interface PricingBookPageProps {
  temporaryEnrollment: boolean;
}

export const PricingBookPage = ({
  temporaryEnrollment,
}: PricingBookPageProps) => {
  const { showV2PriceBook } = useRewardsAndOffers();

  return (
    <PricingPageLayout>
      {showV2PriceBook && !temporaryEnrollment ? (
        <PricingBookV2Container />
      ) : (
        <PricingBookContainer
          temporaryEnrollment={temporaryEnrollment}
          showV2PriceBook={showV2PriceBook}
        />
      )}
    </PricingPageLayout>
  );
};

PricingBookPage.displayName = 'PricingBookPage';
